import { RangeEntryWrapper } from '../../Types'
import { IsVarEmpty } from '../../../../../../../NonReact/utils/GlobalFunctions'
import { COMMA, EMPTY_STRING, EXCLUDE } from '../../../../../../../NonReact/constants/Common'

/**
 * Function to convert the range expression to a string
 *
 * @param rangeWrapper - The range entry wrapper
 *
 * @returns The string representation of the range expression
 */
export const rangeWrapperToString = (rangeWrapper: RangeEntryWrapper): string =>
    rangeWrapper.isRange
        ? `${rangeWrapper.value.minDisplayValue}-${rangeWrapper.value.maxDisplayValue}`
        : `${rangeWrapper.displayValue}`

/**
 * Function to convert a range wrapper to a delimited string for the backend.
 *
 * @param rangeWrapper - The range wrapper
 *
 * @returns The string representation of the range wrapper
 */
export const rangeWrappersToDelimitedString = (rangeWrapper: RangeEntryWrapper): string =>
    rangeWrapper.isRange
        ? `${rangeWrapper.value.minDisplayValue}-${rangeWrapper.value.maxDisplayValue}`
        : rangeWrapper.displayValue.replace(/-/g, '\u2013').replace(/,/g, '\u00B8')

/**
 * Function to convert a list of range wrappers
 *
 * @param rangeWrappers - The list of range wrappers
 * @param shouldDelimit - Should the string be delimited?
 *
 * @returns The string representation of the range wrappers
 */
export const rangeWrappersToString = (
    rangeWrappers: Nullable<RangeEntryWrapper[]>,
    shouldDelimit?: boolean
): string => {
    if (IsVarEmpty(rangeWrappers)) {
        return EMPTY_STRING
    }

    return rangeWrappers
        .map(
            (rangeWrapper: RangeEntryWrapper): string =>
                `${!rangeWrapper.included ? EXCLUDE : EMPTY_STRING}${
                    shouldDelimit ? rangeWrappersToDelimitedString(rangeWrapper) : rangeWrapperToString(rangeWrapper)
                }`
        )
        .join(COMMA)
}
